import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2, Upload } from "lucide-react";
import { Panel } from "@/components/admin/Panel";
import { useSiteSettings } from "@/context/SettingsContext";
import { api, formatErr } from "@/lib/api";

export const FarmVideoPanel = () => {
  const { settings, reload } = useSiteSettings();
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 200 * 1024 * 1024) return toast.error("Video must be 200MB or smaller");
    setBusy(true);
    const fd = new FormData();
    fd.append("video", file);
    try {
      await api.post("/admin/farm-video", fd, { timeout: 600000 });
      await reload();
      toast.success("Video uploaded - the Pull Up To The Farm section is live");
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(false);
    }
  };
  const remove = async () => {
    setBusy(true);
    try {
      await api.delete("/admin/farm-video");
      await reload();
      toast.success("Video removed - section hidden");
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(false);
    }
  };
  const url = settings?.farm_video_url;
  return (
    <Panel title="Pull Up To The Farm video" testId="settings-farm-video-panel">
      {url && <video src={`${process.env.REACT_APP_BACKEND_URL}${url}`} controls className="w-full max-w-md rounded-xl bg-black mb-3" data-testid="settings-farm-video-preview" />}
      <div className="flex flex-wrap gap-2">
        <label className="inline-flex h-10 items-center gap-2 px-4 rounded-full bg-primary text-primary-foreground font-bold text-sm cursor-pointer" data-testid="settings-farm-video-upload">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}{url ? "Replace video" : "Upload video"}
          <input type="file" accept="video/mp4,video/webm,video/quicktime" className="hidden" disabled={busy} onChange={(e) => upload(e.target.files?.[0])} data-testid="settings-farm-video-input" />
        </label>
        {url && <button onClick={remove} className="inline-flex h-10 items-center gap-2 px-4 rounded-full border border-border text-sm font-semibold hover:bg-secondary" data-testid="settings-farm-video-remove"><Trash2 className="h-4 w-4 text-destructive" />Remove</button>}
      </div>
      <p className="text-xs text-muted-foreground mt-2">One video at a time. Uploading a new one replaces the current video. MP4, WEBM or MOV up to 200MB. The section shows on the home page only when a video is uploaded.</p>
    </Panel>
  );
};
